import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {Input} from "reactstrap";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};


function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}

class BrandEMITransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            subventionLists:[{value:'Bank', label: 'Bank'},{value:'Brand', label: 'Brand'},{value:'Merchant', label: 'Merchant'},{value:'Innoviti', label: 'Innoviti'} ],
            subventionValue:'',
            subventionIDs:'',
            categoryLists:[],
            categoryValue:'',
            categoryIDs:'',
            brandLists:[],
            brandValue:'',
            brandIDs:'',
            modelLists:[],
            modelValue:'',
            modelIDs:'',
            emiSchemeLists:[],
            emiSchemeValue:'',
            emiSchemeIDs:'',
            tenureLists:[],
            tenureValue:'',
            tenureIDs:'',
            emiIssuerLists:[],
            emiIssuerValue:'',
            emiIssuerIDs:'',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            brand_list_box: false,
            is_store_loading: true,
            party_master_id: null,
            party_master_name: null,
            ciutidList:[],
            ciutidValue: null,
            ciutidIds:'',
            promotionLists:[],
            promotionValue:'',
            promotionIDs:'',
            maxSpan: [{"days": 7}],
            imei: '',
            isChange: false
        }
    }

    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        //this._get_acq_banks();
        //this._get_issuing_banks();
        //this._get_city();
        //this._getSubvention();
        this._getCategory();
        this._getBrand();
        this.ci_utid();
        //this._getEmiScheme();
        //this._getTenure();
        //this._getEmiIssure();
        
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this._getAllMerchants();
            //this._getModel('');
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.get_filtered_emi_transaction_report('','','','','', this.state.yestSend, this.state.todSend, this.state.is_void, '','', '', '', '', '','' ,'', '', '');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                brand_list_box: true
            })
            this._getPromotion();
            //this._getAllMerchants();
        }
        else if(decoded.object_type=='Merchant') {
            //this._getModel('');
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode);
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant1('merchant', merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                brand_list_box: true
            })
        }
        else if(decoded.object_type=='Chain') {
            //this._getModel('');
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode);
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain1('chain', chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                brand_list_box: true
            })
        }
        else if(decoded.object_type=='Store') {
            //this._getModel('');
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore1('store', storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                brand_list_box: true
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
                brand_list_box: true
            })
        }
        else if(decoded.object_type=='Brand'){
            this._getAllMerchants();
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
                brand_list_box: false
            }, () => {
                this.getPartyID();
            })
            
        }
        else {
            this.unauthorize_access();
        }

    }
    
    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            subventionValue:[],
            subventionIDs:'',
            categoryValue:[],
            categoryIDs:'',
            brandValue:[],
            brandIDs:'',
            modelValue:[],
            modelIDs:'',
            emiSchemeValue:[],
            emiSchemeIDs:'',
            tenureValue:[],
            tenureIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            storeValue:[],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            promotionIDs: '',
            imei: '',
            promotionValue: [],

            ciutidValue: [],
            ciutidIds: '',

            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }

    getPartyID(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            if(response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')){
                this.setState({
                    party_master_id: 3,
                    loading: false,
                    user_id: decoded._id
                });
            }
            else{
                let selected_party2 = [];
                response.data.map((values, index) => {
                    let to_add = '';
                    this.setState({
                        party_master_id: values.party_id
                    }, () => {
                        this.getPartyName();
                        this._getPromotion2();
                    })
                });
                this.setState({
                    selected_party2: selected_party2,
                    loading: false,
                    party_id_mapper: response.data,
                    user_id: decoded._id
                })
            }
        });
    }

    getPartyName() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_name',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                //console.log(values.party_id);
                this.setState({
                    party_master_name: values.party_name,
                    brandIDs: [values.party_name]
                }, () =>{
                    var brandData = [{"value":values.party_name, "label":values.party_name}]
                    this.changeBrand1(brandData);
                })
            })
        });
    }

    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        // if(subMenuPermissions.includes("transaction_reports")===false || reportPermissions.includes("emi_transaction")===false ){
        //     this.unauthorize_access();
        // }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    refressOnDateChange(){
        this._getCategory();
        this._getBrand();
        //this._getModel('');
        this.ci_utid();
        //this._getEmiScheme();
        this._getTenure();
        this._getEmiIssure();
        this.setState({
            subventionValue:[],
            subventionIDs:'',
            categoryValue:[],
            categoryIDs:'',
            brandValue:[],
            brandsIDs:'',
            modelValue:[],
            modelIDs:'',
            // emiSchemeValue:null,
            // emiSchemeIDs:'',
            tenureValue:[],
            tenureIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
        });
    }
    get_filtered_emi_transaction_report(mids, cids, sids, bids, cityids, fromdate, todate, isVoid, subventionIDs, categoryIDs, brandIDs, modelIDs, emiSchemeIDs, tenureIDs, emiIssuerIDs, ciutidIds, promotionIDs, imei) {
        //alert(todate);
        //console.log(mids); console.log(cids); console.log(sids); console.log(bids); console.log(cityids); console.log(fr);
        var that = this;
        var postData = {
            mids: mids,
            cids: cids,
            sids: sids,
            bids: bids,
            cityids: cityids,
            // fr: fr,
            yestSend: fromdate,
            todSend: todate,
            is_void: isVoid,
            txn_type: 'EMI',
            subventionIDs: subventionIDs,
            categoryIDs: categoryIDs,
            brandIDs: brandIDs,
            modelIDs: modelIDs,
            emiSchemeIDs: emiSchemeIDs,
            tenureIDs: tenureIDs,
            emiIssuerIDs: emiIssuerIDs,
            utIDs: ciutidIds,
            promotionIDs: promotionIDs,
            imei: imei
        };

        disabledBody()
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        // if(object_type === 'Merchant' && this.state.merchantID===''){
        //     merchants = object_code;
        // }
        // if(object_type==='Chain' && this.state.chainID===''){
        //     chains = object_code;
        // }
        // if(object_type==='Store' && this.state.storeID===''){
        //     stores = object_code;
        // }
        // if(object_type==='Acquiring Bank' && this.state.storeID===''){
        //     acqBank = object_code;
        // }
        // if(object_type==='Issuing Bank' && this.state.storeID===''){
        //     emiIssuer = object_code;
        // }
        this.setState({
            active_mids: merchants,
            active_cids: chains,
            active_sids: stores,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_is_void: this.state.is_void,
            active_categoryIDs: this.state.categoryIDs,
            active_promotionIDs: this.state.promotionIDs,
            active_brandIDs: this.state.brandIDs,
            active_modelIDs: this.state.modelIDs,
            active_emiSchemeIDs: this.state.emiSchemeIDs,
            active_utid: this.state.ciutidIds,
            active_imei: this.state.imei,
            active_void: this.state.void
        })

        if ($.fn.DataTable.isDataTable('#BrandEmiTraTable')) {
            $('#BrandEmiTraTable').DataTable().clear().destroy();
        }
        var EmiTraTable = $('#BrandEmiTraTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[10, 20, 50], [10, 20, 50]],
                ajax: {
                    url:config.get('API_URL')+ "/brandemi/brand_emi_transaction_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody()
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    }
                },

                columns: [
                    {"data":"Transaction ID", "width":"150px"},
                    {"data":"Merchant", "width":"150px"},
                    {"data":"Chain", "width":"100px"},
                    {"data":"Store", "width":"100px"},
                    {"data":"City"},
                    {"data":"Brand"},
                    {"data":"Category"},
                    {"data":"Model"},
                    {"data":"Amount"},
                    {"data":"Transaction Date"},
                    {"data":"Transaction Time"},
                    {"data":"Btid"},
                    {"data":"Utid"},
                    {"data": "Acquirer Bank"},
                    {"data":"Card Issuer"},
                    {"data": "Card Type"},
                    {"data": "Tenure"},
                    {"data":"Invoice No"},
                    {"data": "IMEI/Serial Number"},
                    {"data": "Scheme Name"},
                    {"data": "Promotion Name"}
                ],
                "columnDefs": [
                    // {  render: function (data) {
                    //         return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                    //     },
                    //     "width": "80px",
                    //     "targets": 8
                    // },
                    // {
                    //     render: function (data) {
                    //         if(data==''|| data==null || data=='null'){
                    //             return '<td >&nbsp;</td>';
                    //         }
                    //         else {
                    //             return '<td ><a href="#" data-code ="' + data + '">Get Receipt</a> &nbsp;</td>';
                    //         }
                    //     },
                    //     className: "charge_slip",
                    //     targets: 7,
                    //     aTargets: [-1]
                    // },
                ],
            });
        // $('#BrandEmiTraTable').on('click', 'td.charge_slip a', function (e) {
        //     e.preventDefault();
        //     var code = $(this).data("code");
        //     //alert(code);
        //     window.open( code, 'popUpWindow', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
        //     // $.ajax({
        //     //     url:config.get('API_URL')+ "/reports/generate_slip/?code="+code,
        //     //     type: 'GET',
        //     //     beforeSend: function (request) {
        //     //         request.setRequestHeader("Authorization", localStorage.usertoken);
        //     //     },
        //     //     success: function (response) {
        //     //         //console.log(response);
        //     //         let win=window.open('about:blank','popUpWindow', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes' )
        //     //         //writeToWindow(win,'Loading...')
        //     //
        //     //         win.document.write(response)
        //     //         //action(this.state.opened ? 'Closing the window' : 'Opening the window')()
        //     //         //that.setState()
        //     //         //var ss = response.replace(/(\r\n|\n|\r)/gm, "");
        //     //         // var htmlObject = $(response);  console.log(htmlObject);
        //     //         // that.setState({
        //     //         //     opened: true,
        //     //         //     chargeSlipPopup: true,
        //     //         //     slipData:response
        //     //         // })
        //     //
        //     //     },
        //     //     // dataType: 'html'
        //     // })
        // })

    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        })//.then(() => {
        //     var merchantData = [];
        //     merchantData.push({value: "RELI0001", label: "Reliance Retail Ltd"});
        //     this.changeMerchant('', merchantData);
        // });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        var is_enable = compareValues(midArray, this.state.active_mids);
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }

    }

    changeMerchant1(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: []
        });
        this.get_filtered_emi_transaction_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }

    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        }

    }

    changeChain1(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: []
        });
        this.get_filtered_emi_transaction_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
           this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        }

    }

    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }

    changeStore(login_type, optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                    this.state.storeList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(sidArray, this.state.active_sids);
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected,
            isChange: is_enable
        });
        //this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);
    }

    changeStore1(login_type, optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                    this.state.storeList.move(index,0).join(',');
                }
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,
           this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);
    }

    ci_utid(){
        // const token = localStorage.usertoken;
        // const decoded = jwt_decode(token);
        axios.post(config.get('API_URL')+'/brandemi/ci_utid/',{
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            txn_type: 'EMI'
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((ci_utid, index) => {
                    this.state.ciutidList.push({value: ci_utid.upper, label: ci_utid.upper})
                });
            }
        });
    }

    changeUtid(optionSelected){
        let value='';
        let utidArray = [];
        if(optionSelected.length<1){
            value = null;
            utidArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                utidArray.push(mids.value)
                var index = this.state.ciutidList.findIndex(obj => obj.value==mids.value);
                this.state.ciutidList.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(utidArray, this.state.active_utid);
        this.setState({
            ciutidIds:utidArray,
            ciutidValue:optionSelected,
            isChange: is_enable
        });
        //this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //    this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, utidArray, this.state.promotionIDs, this.state.imei);
    }

    _get_acq_banks() {
        axios.get(config.get('API_URL')+'/reports/acq-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading: false
        })
    }

    change_acq_banks(optionSelected){ //console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected.length<1){
            value = null;
            acqBankArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        this.setState({
            acqBankIds:acqBankArray,
            acqBankValue:optionSelected,
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);
    }
    _get_city(){
        axios.get(config.get('API_URL')+'/reports/get-city/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((city, index) => {
                    this.state.cityLists.push({value: city.city_name, label: city.city_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeCity(optionSelected){
        let value='';
        let cityArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                cityArray.push(mids.value)
                var index = this.state.cityLists.findIndex(obj => obj.value==mids.value);
                this.state.cityLists.move(index,0).join(',');
            });
        }
        this.setState({
            cityIds:cityArray,
            cityValue:optionSelected,
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, cityArray,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);
    }

    changeSubvention(optionSelected){
        let value='';
        let subArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                subArray.push(mids.value)
            });
        }
        this.setState({
            subventionIDs:subArray,
            subventionValue:optionSelected,
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, subArray, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);
    }
    _get_issuing_banks(){
        axios.get(config.get('API_URL')+'/invoice/all_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    this.state.issuerBankList.push({value: issuBank.issuing_bank_id, label: issuBank.issuing_bank_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    _getCategory(){
        axios.post(config.get('API_URL')+'/reports/get-emi-category/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.setState({
                categoryLists:[]
            })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((category, index) => {
                    this.state.categoryLists.push({value: category.category, label: category.category})
                });
            }
        });
    }
    changeCategory(optionSelected){
        let value='';
        let catArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                catArray.push(mids.value)
                var index = this.state.categoryLists.findIndex(obj => obj.value==mids.value);
                this.state.categoryLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(catArray, this.state.active_categoryIDs);
        this.setState({
            categoryIDs:catArray,
            categoryValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, catArray, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei);
    }
    changeSubvention(optionSelected){
        let value='';
        let subArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                subArray.push(mids.value)

            });
        }
        this.setState({
            subventionIDs:subArray,
            subventionValue:optionSelected,
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, subArray, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs,this.state.ciutidIds, this.state.promotionIDs, this.state.imei)
    }

    _getBrand(){
        axios.post(config.get('API_URL')+'/brandemi/get_party_list/',{
                party_type1: 'Brand',
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    brandLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((brand, index) => {
                    this.state.brandLists.push({value: brand.party_name, label: brand.party_name})
                });
            }
        });
    }
    changeBrand(optionSelected){
        let value='';
        let brandArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                brandArray.push(mids.value)
                var index = this.state.brandLists.findIndex(obj => obj.value==mids.value);
                this.state.brandLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(brandArray, this.state.active_brandIDs);
        this.setState({
            brandIDs:brandArray,
            brandValue:optionSelected,
        });
        this.setState({
            modelLists:[],
            modelValue:null,
            modelIDs:'',
            isChange: is_enable
        })
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, brandArray, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs,this.state.ciutidIds, this.state.promotionIDs, this.state.imei)
        //this._getModel(brandArray);
    }

    changeBrand1(optionSelected){
        let value='';
        let brandArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                brandArray.push(mids.value)
                // var index = this.state.brandLists.findIndex(obj => obj.value==mids.value);
                // this.state.brandLists.move(index,0).join(',');
            });
        }
        this.setState({
            brandIDs:brandArray,
            brandValue:optionSelected,
            modelLists:[],
            modelValue:null,
            modelIDs:'',
        }, () => {
            this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
                this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, brandArray, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs,this.state.ciutidIds, this.state.promotionIDs, this.state.imei)
            //this._getModel(brandArray);
            //this._getAllMerchants();
        });
        
    }


    _getModel(brandArray){
        axios.post(config.get('API_URL')+'/reports/get-emi-model/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
                brandArray: brandArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    modelLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((model, index) => {
                    this.state.modelLists.push({value: model.model, label: model.model})
                });
            }
        });
    }
    changeModel(optionSelected){
        let value='';
        let modelArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                modelArray.push(mids.value)
                var index = this.state.modelLists.findIndex(obj => obj.value==mids.value);
                this.state.modelLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(modelArray, this.state.active_modelIDs);
        this.setState({
            modelIDs:modelArray,
            modelValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, modelArray, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs,this.state.ciutidIds,this.state.promotionIDs, this.state.imei)
    }

    _getPromotion(list_setter){
            axios.get(config.get('API_URL') + '/brandemi/get_campaign',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    list_setter: list_setter
                }
            }).then(response => {
                    // console.log(response.data);
                    this.setState({
                        promotionLists:[]
                    })
                if(Array.isArray(response.data) && response.data.length) {
                    response.data.map((promotion, index) => {
                        this.state.promotionLists.push({value: promotion.id, label: promotion.campaign_name})
                    });
                }
            });
        }

        _getPromotion2(list_setter){
            axios.get(config.get('API_URL') + '/brandemi/get_campaign_brand',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    party_master_id: this.state.party_master_id
                }
            }).then(response => {
                    // console.log(response.data);
                    this.setState({
                        promotionLists:[]
                    })
                if(Array.isArray(response.data) && response.data.length) {
                    response.data.map((promotion, index) => {
                        this.state.promotionLists.push({value: promotion.id, label: promotion.campaign_name})
                    });
                }
            });
        }


    changePromotion(optionSelected){
        let value='';
        let promotionArray = [];
        if(optionSelected===null){
            value = null;
            promotionArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                promotionArray.push(mids.value)
                var index = this.state.promotionLists.findIndex(obj => obj.value==mids.value);
                this.state.promotionLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(promotionArray, this.state.active_promotionIDs);
        this.setState({
            promotionIDs:promotionArray,
            promotionValue:optionSelected,
            isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs,this.state.ciutidIds, promotionArray, this.state.imei)
    }

    _getEmiScheme(){
        axios.post(config.get('API_URL')+'/reports/get-emi-scheme-filter/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((scheme, index) => {
                    this.state.emiSchemeLists.push({value: scheme.issuer_scheme_code, label: scheme.issuer_scheme_name})
                });
            }
        });
    }
    changeEmiScheme(optionSelected){
        let value='';
        let schemeArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                schemeArray.push(mids.value)
                var index = this.state.emiSchemeLists.findIndex(obj => obj.value==mids.value);
                this.state.emiSchemeLists.move(index,0).join(',');
            });
        }
        this.setState({
            emiSchemeIDs:schemeArray,
            emiSchemeValue:optionSelected,
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs,schemeArray, this.state.tenureIDs, this.state.emiIssuerIDs,this.state.ciutidIds, this.state.promotionIDs, this.state.imei)
    }

    _getTenure(){
        axios.post(config.get('API_URL')+'/reports/get-emi-tenure/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    tenureLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((Tenure, index) => {
                    this.state.tenureLists.push({value: Tenure.tenure, label: Tenure.tenure})
                });
            }
        });
    }
    changeTenure(optionSelected){
        let value='';
        let tenureArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                tenureArray.push(mids.value)
                var index = this.state.tenureLists.findIndex(obj => obj.value==mids.value);
                this.state.tenureLists.move(index,0).join(',');
            });
        }
        this.setState({
            tenureIDs:tenureArray,
            tenureValue:optionSelected,
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.schemeIDs, tenureArray, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei)
    }

    _getEmiIssure(){
        axios.post(config.get('API_URL')+'/reports/get-emi-issuer-filter/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    emiIssuerLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuer, index) => {
                    this.state.emiIssuerLists.push({value: issuer.issuing_bank_name, label: issuer.issuing_bank_name})
                });
            }
        });
    }
    changeEmiIssuer(optionSelected){
        let value='';
        let emiIssuerArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                emiIssuerArray.push(mids.value)
                var index = this.state.emiIssuerLists.findIndex(obj => obj.value==mids.value);
                this.state.emiIssuerLists.move(index,0).join(',');
            });
        }
        this.setState({
            emiIssuerIDs:emiIssuerArray,
            emiIssuerValue:optionSelected,
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, emiIssuerArray, this.state.ciutidIds, this.state.promotionIDs, this.state.imei)
    }
    // handleEvent(event, picker, e) {
    //     this.setState({
    //         todSend: moment(picker.endDate).format('YYYY-MM-DD'),
    //         yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
    //         datefromShow: moment(picker.startDate).format('D MMM YYYY'),
    //         dateToShow: moment(picker.endDate).format('D MMM YYYY')
    //     }, () => {
    //         if(event.type=='apply'){
    //             var is_date_change = false;
    //             if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
    //                 is_date_change = false;
    //             } else {
    //                 is_date_change = true;
    //             }
    //             var a = moment(this.state.todSend);
    //             var b = moment(this.state.yestSend);
    //             var days_beet = a.diff(b, 'days');
    //             if(days_beet>6) {
    //                 this.setState({
    //                     dateTo:tod,
    //                     dateLimit:date_limit,
    //                     dateToShow:todShow,
    //                     todSend:todSend,
    //                     yestSend:yestSend,
    //                     datefrom:yest,
    //                     datefromShow:yestShow
    //                 }, () =>{
    //                     alert("Date range too large. Please select a date range of 7 days at a time");
    //                     return false;
    //                 })
    //             }
    //             else{
    //                 this.setState({
    //                     dateTo:tod,
    //                     dateLimit:date_limit,
    //                     dateToShow:todShow,
    //                     todSend:todSend,
    //                     yestSend:yestSend,
    //                     datefrom:yest,
    //                     datefromShow:yestShow,
    //                     isChange: is_date_change
    //                 })
    //                 // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
    //                 //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei)
    //                 this.refressOnDateChange();
    //             }
    //         }
    //     });    
    // }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY'),

        });
         if(event.type=='apply'){
             var is_date_change = false;
             if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
                 is_date_change = false;
             } else {
                 is_date_change = true;
             }
             this.setState({
                 isChange: is_date_change
             })
        //     this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //         this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
            this.refressOnDateChange();

        }
    }

    handleCheckVoid(e)
    {
        var is_void = 1;
        if(e.target.checked===true){
            is_void = 1
        } else {
            is_void = 0;
        }
        var is_enable = compareValues(is_void, this.state.active_void);
        this.setState({ is_void:is_void, isChange: is_enable})
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei)

    }
    transactionReportDownload (e){
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if(days_beet>14) {
            alert("Date range too large. Please select a date range of 15 days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            is_void: this.state.is_void,
            download: true,
            txn_type: 'EMI',
            subventionIDs: this.state.subventionIDs,
            categoryIDs: this.state.categoryIDs,
            brandIDs: this.state.brandIDs,
            modelIDs: this.state.modelIDs,
            emiSchemeIDs: this.state.emiSchemeIDs,
            tenureIDs: this.state.tenureIDs,
            emiIssuerIDs: this.state.emiIssuerIDs,
            utIDs: this.state.ciutidIds,
            promotionIDs: this.state.promotionIDs,
            imei: this.state.imei
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/brandemi/brand_emi_transaction_report_download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'_101brand_emi_transaction_report';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Brand EMI Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                        <div><label> Date Filter: </label></div>
                                        <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                         onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}
                                                         maxSpan={this.state.maxSpan}>
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                            <input type="text" name="dateRange" className="form-control dateRangeInput"
                                                   value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                        </DateRangePicker>
                                    </div>
                                    {this.state.merchant_list_box ===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Merchants</label>
                                            <ReactMultiSelectCheckboxes name="merchants"
                                                isMulti
                                                value={this.state.merchantValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeMerchant.bind(this,'')}
                                                options={this.state.merchantList}
                                                placeholderButtonLabel="Select [Merchant]"
                                            />

                                            <div className="clearfix"></div>
                                        </div> : null}
                                    {this.state.chain_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Chain </label>
                                            <ReactMultiSelectCheckboxes name="chain"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.chainValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeChain.bind(this,'')}
                                                options={this.state.chainList}
                                                placeholderButtonLabel="Select [Chain]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>: null }
                                    {this.state.store_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Store </label>
                                            <ReactMultiSelectCheckboxes name="store"
                                                                        isMulti
                                                                        isLoading={this.state.is_store_loading}
                                                                        components={{ MenuList }}
                                                                        value={this.state.storeValue}
                                                                        styles={customStyles} className="report-listbox"
                                                                        isClearable={false}
                                                                        onChange={this.changeStore.bind(this, '')}
                                                                        options={this.state.storeList}
                                                                        placeholderButtonLabel="Select [Store]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>: null }
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Utid: </label>
                                        <ReactMultiSelectCheckboxes name="Utid"
                                            isMulti
                                            components={{ MenuList }}
                                            value={this.state.ciutidValue}
                                            styles={customStyles} className="report-listbox"
                                            isClearable={false}
                                            onChange={this.changeUtid.bind(this)}
                                            options={this.state.ciutidList}
                                            placeholderButtonLabel="Select [Utid]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    {/* {this.state.acq_bank_list_box===true?
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Acquirer:</label>
                                        <ReactMultiSelectCheckboxes name="acqurier"
                                            isMulti
                                            value={this.state.acqBankValue}
                                            styles={customStyles} className="report-listbox"
                                            isClearable={false}
                                            onChange={this.change_acq_banks.bind(this)}
                                            options={this.state.acqBankList}
                                            placeholderButtonLabel="Select [Acquirer]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    : null }
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Subvention </label>
                                        <ReactMultiSelectCheckboxes name="subvention"
                                                isMulti
                                                value={this.state.subventionValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeSubvention.bind(this)}
                                                options={this.state.subventionLists}
                                                placeholderButtonLabel="Select [Subvention]"
                                        />
                                        <div className="clearfix"></div>
                                    </div> */}
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Category </label>
                                        <ReactMultiSelectCheckboxes name="category"
                                                isMulti
                                                value={this.state.categoryValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeCategory.bind(this)}
                                                options={this.state.categoryLists}
                                                placeholderButtonLabel="Select [Category]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>

                                    {this.state.brand_list_box===true?
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Brand:</label>
                                        <ReactMultiSelectCheckboxes name="brand"
                                                isMulti
                                                value={this.state.brandValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeBrand.bind(this)}
                                                options={this.state.brandLists}
                                                placeholderButtonLabel="Select [Brand]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>: null}
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Model: </label>
                                        <ReactMultiSelectCheckboxes name="model"
                                                isMulti
                                                value={this.state.modelValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeModel.bind(this)}
                                                options={this.state.modelLists}
                                                placeholderButtonLabel="Select[Model]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Promotion: </label>
                                        <ReactMultiSelectCheckboxes name="promotion"
                                                isMulti
                                                value={this.state.promotionValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changePromotion.bind(this)}
                                                options={this.state.promotionLists}
                                                placeholderButtonLabel="Select[Promotion]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> IMEI/Serial Number: </label>
                                        <Input className="filter-height" id="imei" value={this.state.imei} onChange={(e)=> {
                                            let {imei} = this.state;
                                            imei = e.target.value;
                                            var imei1 = e.target.value
                                            var is_enable = compareValues(imei1, this.state.imei);
                                            this.setState({
                                                imei: imei,
                                                isChange: is_enable
                                            }, () => {
                                                // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
                                                //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs,this.state.ciutidIds, this.state.promotionIDs, imei)
                                            })
                                        }}/>
                                            {/* <Input  name="imei" id="imei" value={this.state.imei}  onChange={this.onChangeIMEI}/> */}
                                        <div className="clearfix"></div>
                                    </div>
                                    {/* <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Scheme: </label>
                                        <ReactMultiSelectCheckboxes name="emi_scheme"
                                                isMulti
                                                value={this.state.emiSchemeValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeEmiScheme.bind(this)}
                                                options={this.state.emiSchemeLists}
                                                placeholderButtonLabel="Select [ EMI Scheme]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Tenure: </label>
                                        <ReactMultiSelectCheckboxes name="tenure"
                                                                    EMI Issuer isMulti
                                                value={this.state.tenureValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeTenure.bind(this)}
                                                options={this.state.tenureLists}
                                                placeholderButtonLabel="Select [Tenure]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Issuer: </label>
                                        <ReactMultiSelectCheckboxes name="emi_issure"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.emiIssuerValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeEmiIssuer.bind(this)}
                                                options={this.state.emiIssuerLists}
                                                placeholderButtonLabel="Select [EMI Issuer]"
                                        />
                                        <div className="clearfix"></div>
                                    </div> */}
                                    <div className="col-md-3 padd30 col-md-2 filter-bottom5 padd-5">
                                        <label><input type="checkbox" name="is_void" onChange={this.handleCheckVoid.bind(this)} checked={(this.state.is_void==1)? true : false} /> &nbsp; Show Void Transaction</label>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }

                                        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_emi_transaction_report.bind(this, this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds, this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, this.state.emiIssuerIDs, this.state.ciutidIds, this.state.promotionIDs, this.state.imei)}>Apply</button>&nbsp; &nbsp;
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>

                                    </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.transactionReportDownload.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="BrandEmiTraTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th width="150px">Transaction ID</th>
                                                <th width="150px">Merchant</th>
                                                <th width="100px">Chain</th>
                                                <th width="100px">Store</th>
                                                <th>City</th>
                                                <th>Brand</th>
                                                <th>Category</th>
                                                <th>Model</th>
                                                <th>Amount</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Btid</th>
                                                <th>Utid</th>
                                                <th>Acquirer Bank</th>
                                                <th>Card Issuer</th>
                                                <th>Card Type</th>
                                                <th>Tenure</th>
                                                <th>Invoice No</th>
                                                <th>IMEI/Serial Number</th>
                                                <th>Scheme Name</th>
                                                <th>Promotion Name</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BrandEMITransactionReport;